(function () {
  'use strict';

  if (window.AxiomVariantCursorParallax) return;
  window.AxiomVariantCursorParallax = true;

  const selector = [
    'button[data-option-position]',
    'button[data-qv-option-button]',
    'button[data-product-card-swatch]',
    'button[data-hero-hotspots-option]'
  ].join(',');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  let activeControl = null;
  let frame = 0;
  let pointerX = 0;
  let pointerY = 0;
  const states = new Map();

  function isEnabled() {
    return document.body.dataset.variantCursorParallax === 'true' && finePointer.matches && !reducedMotion.matches;
  }

  function resetControl(control) {
    if (!control) return;
    const state = states.get(control);
    if (!state) return;
    state.targetX = 0;
    state.targetY = 0;
    state.targetScale = 1;
    state.resetting = true;
    requestFrame();
  }

  function stateFor(control) {
    let state = states.get(control);
    if (state) return state;
    control.classList.add('is-variant-cursor-parallax-active');
    state = {
      x: 0,
      y: 0,
      scale: 1,
      targetX: 0,
      targetY: 0,
      targetScale: 1,
      resetting: false
    };
    states.set(control, state);
    return state;
  }

  function requestFrame() {
    if (!frame) frame = requestAnimationFrame(animateControls);
  }

  function animateControls() {
    frame = 0;
    let shouldContinue = false;

    states.forEach(function (state, control) {
      if (!control.isConnected || !isEnabled()) {
        control.style.removeProperty('translate');
        control.style.removeProperty('scale');
        control.classList.remove('is-variant-cursor-parallax-active');
        states.delete(control);
        return;
      }

      state.x += (state.targetX - state.x) * 0.18;
      state.y += (state.targetY - state.y) * 0.18;
      state.scale += (state.targetScale - state.scale) * 0.18;

      const settled = Math.abs(state.targetX - state.x) < 0.02 &&
        Math.abs(state.targetY - state.y) < 0.02 &&
        Math.abs(state.targetScale - state.scale) < 0.001;

      if (settled) {
        state.x = state.targetX;
        state.y = state.targetY;
        state.scale = state.targetScale;
      } else {
        shouldContinue = true;
      }

      if (state.resetting && settled) {
        control.style.removeProperty('translate');
        control.style.removeProperty('scale');
        control.classList.remove('is-variant-cursor-parallax-active');
        states.delete(control);
        return;
      }

      control.style.translate = `${state.x.toFixed(2)}px ${state.y.toFixed(2)}px`;
      control.style.scale = state.scale.toFixed(3);
    });

    if (shouldContinue) requestFrame();
  }

  function updateControl() {
    const control = activeControl;
    if (!control || !control.isConnected || !isEnabled()) {
      resetControl(control);
      return;
    }

    const rect = control.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    const distanceX = pointerX - (rect.left + rect.width / 2);
    const distanceY = pointerY - (rect.top + rect.height / 2);
    const distance = Math.hypot(distanceX, distanceY);
    const radius = Math.max(96, rect.width * 2.8);

    if (distance > radius) {
      resetControl(control);
      return;
    }

    const proximity = 1 - distance / radius;
    const strength = 0.22 * proximity;
    const state = stateFor(control);
    state.targetX = distanceX * strength;
    state.targetY = distanceY * strength;
    state.targetScale = 1 + 0.08 * proximity;
    state.resetting = false;
    requestFrame();
  }

  function controlFromEvent(event) {
    if (!event.target || !event.target.closest) return null;
    const control = event.target.closest(selector);
    if (
      control &&
      control.hasAttribute('data-product-card-swatch') &&
      document.body.dataset.variantCursorParallaxProductCards !== 'true'
    ) {
      return null;
    }
    return control;
  }

  document.addEventListener('pointermove', function (event) {
    if (event.pointerType === 'touch') return;

    const control = controlFromEvent(event);
    if (activeControl && activeControl !== control) resetControl(activeControl);
    activeControl = control;
    if (!control) return;

    pointerX = event.clientX;
    pointerY = event.clientY;
    updateControl();
  }, { passive: true });

  document.addEventListener('pointerout', function (event) {
    const control = controlFromEvent(event);
    if (!control || (event.relatedTarget && control.contains(event.relatedTarget))) return;
    resetControl(control);
    if (activeControl === control) activeControl = null;
  }, true);

  reducedMotion.addEventListener('change', function () {
    if (!reducedMotion.matches) return;
    states.forEach(function (_state, control) {
      control.style.removeProperty('translate');
      control.style.removeProperty('scale');
      control.classList.remove('is-variant-cursor-parallax-active');
    });
    states.clear();
    activeControl = null;
  });
})();
